import { BaseMapper } from '@ps/utils';

import { TransactionStatusDto } from '../dtos/transaction-status.dto';
import { TransactionStatus } from '../../models/report.model';

export class TransactionStatusMapper extends BaseMapper<
  TransactionStatusDto,
  TransactionStatus
> {
  public fromDto(
    transactionStatusDto: TransactionStatusDto,
  ): TransactionStatus {
    return {
      id: transactionStatusDto.id,
      name: transactionStatusDto.name,
    };
  }
}
